import greenHead from "./greenHead.png";
import "./styles.css";

export default function GreenHead() {
    return (
        <img src={greenHead} alt="Hojas decorativas" className="greenhead-image"/>
    );
};